// extracted by mini-css-extract-plugin
module.exports = {"Link":"LinkWithTransition-module--Link--1ZXSd"};